import React from 'react';
import { Icon } from 'semantic-ui-react';

const IconComponent = (props) => <Icon {...props} />;

export default IconComponent;
